import { defineMessages } from 'react-intl';

export const billableMetricsMessages = defineMessages({
    billableMetrics: {
        id: 'billable-metrics',
        defaultMessage: 'Billable metrics',
    },
    billableMetric: {
        id: 'billable-metric',
        defaultMessage: 'Billable metric',
    },
    measurementType: {
        id: 'measurement',
        defaultMessage: 'Measurement',
    },
    aggregationType: {
        id: 'aggregation-type',
        defaultMessage: 'Aggregation',
    },
    stateful: {
        id: 'stateful',
        defaultMessage: 'Stateful',
    },
    metered: {
        id: 'metered',
        defaultMessage: 'Metered',
    },
    timeWeighted: {
        id: 'time-weighted',
        defaultMessage: 'Time weighted',
    },
    endOfPeriod: {
        id: 'end-of-period',
        defaultMessage: 'End of period',
    },
    maxInPeriod: {
        id: 'max-in-period',
        defaultMessage: 'Max in period',
    },
    count: {
        id: 'count',
        defaultMessage: 'Count',
    },
    sum: {
        id: 'sum',
        defaultMessage: 'Sum',
    },
    max: {
        id: 'max',
        defaultMessage: 'Max',
    },
    latest: {
        id: 'latest',
        defaultMessage: 'Latest',
    },
    addBillableMetricSubtitle: {
        id: 'add-billable-metric-subtitle',
        defaultMessage: 'Create a new billable metric',
    },
    editBillableMetricSubtitle: {
        id: 'edit-billable-metric-subtitle',
        defaultMessage: 'Edit billable metric {entity}',
    },
    createBillableMetricSuccess: {
        id: 'create-billable-metric-success',
        defaultMessage: 'Billable metric created',
    },
    createBillableMetricSuccessDescription: {
        id: 'create-billable-metric-success-description',
        defaultMessage: 'Billable metric {entry} has been successfully created.',
    },
    updateBillableMetricSuccess: {
        id: 'update-billable-metric-success',
        defaultMessage: 'Billable metric updated',
    },
    updateBillableMetricSuccessDescription: {
        id: 'update-billable-metric-success-description',
        defaultMessage: 'Billable metric {entity} has been successfully updated.',
    },
    deleteBillableMetric: {
        id: 'delete-billable-metric',
        defaultMessage: 'Delete billable metric',
    },
    deleteBillableMetricSubtitle: {
        id: 'delete-billable-metric-subtitle',
        defaultMessage: 'Permanently delete billable metric {entity}',
    },
    confirmDeleteBillableMetric: {
        id: 'confirm-delete-billable-metric',
        defaultMessage: 'Are you sure you want to delete this billable metric? This action cannot be undone.',
    },
    deleteBillableMetricSuccessDescription: {
        id: 'delete-billable-metric-success-description',
        defaultMessage: 'The billable metric has been successfully deleted.',
    },
    invalidAggregationError: {
        id: 'custom-error:invalid_aggregation_for_measurement_type',
        defaultMessage: 'That aggregation is not valid for the selected measurement type.',
    },
    unsupportedAggregationError: {
        id: 'custom-error:unsupported_aggregation',
        defaultMessage: 'That aggregation is not supported yet.',
    },
    metricUnitHint: {
        id: 'billable-metric-unit-hint',
        defaultMessage: "The metric's natural unit. It does not override the plan item's unit on invoices.",
    },
});
